import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

import { IConnectedApplicationType } from '../types/ConnectedApplicationType';


export interface IGetConnectedApplicationsResult extends IGetItemsResult {
  directTrustApps: IConnectedApplicationType[];
  easApps: IConnectedApplicationType[];
}

export class GetConnectedApplications extends Request<{}, IGetConnectedApplicationsResult>  {
  constructor() {
    super('getConnectedAppsOnSite', {});
  }
}

